import { ITab } from 'api-paths-cas';

export enum UserRole {
  Admin = '[Admin]',
  UniAdmin = '[UniAdmin]',
  Uni = '[Uni]',
  UniSecure = '[UniSecure]',
  UniLite = '[UniLite]',
  Agent = '[Agent]',
  Enroly = '[Enroly]',
  AgencyAdmin = '[AgencyAdmin]',
  Partner = '[Partner]',
  ImmigrationProvider = '[ImmigrationProvider]',
  Unknown = '[Unknown]',
}

export interface CustomTab extends ITab {
  id: string;
  label: string;
  group: string;
  statuses: string[];
  count: number;
  active: boolean;
  color: string;
}

export interface GroupedCustomTabs {
  [group: string]: Array<CustomTab>;
}
